import { getTimezoneOffset, utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

const _defaultDate = Date;

export function getRealDate(): Date {
  return new _defaultDate();
}

function restoreDate() {
  if (!_defaultDate) {
    return;
  }
  Date = _defaultDate;
  _isDateMonkeyPatchedAlready = false;
}

const _defaultToISOString = Date.prototype.toISOString;
export function defaultToISOString(date: Date): string;
export function defaultToISOString(date: Date | null | undefined) {
  if (!date) return null;
  return _defaultToISOString.bind(date)();
}

export function getCurrentTimezoneIana() {
  return _currentTimezoneIana;
}
export function convertToCurrentTimezone(date: Date): Date;
export function convertToCurrentTimezone(
  date: Date | null | undefined,
): Date | null | undefined;
export function convertToCurrentTimezone(
  date: Date | null | undefined,
): Date | null | undefined {
  return date ? utcToZonedTime(date, _currentTimezoneIana!) : null;
}

export function convertFromCurrentTimezone(date: Date): Date;
export function convertFromCurrentTimezone(
  date: Date | null | undefined,
): Date | null | undefined;
export function convertFromCurrentTimezone(
  date: Date | null | undefined,
): Date | null | undefined {
  return date ? zonedTimeToUtc(date, _currentTimezoneIana!) : null;
}

export function convertToDateInClinicTimezone(date: Date): Date;
export function convertToDateInClinicTimezone(
  date: Date | null | undefined,
): Date | null | undefined {
  if (!date) return date;
  const offset = getTimezoneOffset(_currentTimezoneIana!);
  return new Date(date.getTime() + offset);
}

export function saveTimezone(timezoneIanaName: string | null) {
  if (timezoneIanaName === null) {
    window.localStorage.removeItem('timezone');
  } else {
    window.localStorage.setItem('timezone', timezoneIanaName);
  }
}
function loadTimezone() {
  return window.localStorage.getItem('timezone');
}
export function loadSavedTimezoneIfPresent() {
  const timezone = loadTimezone();
  if (!timezone) return;
  forceTimezone(timezone);
}

let _currentTimezoneIana: string | undefined = undefined;
let _isDateMonkeyPatchedAlready = false;
export function forceTimezone(newTimezoneIanaName: string) {
  if (_currentTimezoneIana === newTimezoneIanaName) return;
  saveTimezone(newTimezoneIanaName);
  const offset = getTimezoneOffset(newTimezoneIanaName);
  if (Number.isNaN(offset)) {
    console.error(`Cannot get offset of time zone "${newTimezoneIanaName}"`);
    return;
  }

  _currentTimezoneIana = newTimezoneIanaName;
  if (!_isDateMonkeyPatchedAlready) {
    Date = function (...args: any[]) {
      // we only patch dates in the following cases:
      // - if it's called with zero parameters: new Date(). In this case we should return the current date in desired Timezone
      // - if it's called with string ending with 'Z', which means it was received from backend.
      //    We don't need to patch dates in e.g. '2022-01-10' format, because it means a start of a day (e.g. birthday).
      // - we don't do any patching in other cases, because otherwise it breaks different date-fns functions like startOfDay, addMinutes, etc.
      let shouldPatch = args.length === 0;
      if (args.length === 1 && typeof args[0] === 'string') {
        shouldPatch = args[0].endsWith('Z');
      }

      // we use default browser Date constructor here.
      const resultInDefaultTimezone = new (_defaultDate as any)(
        ...args,
      ) as Date;
      if (!shouldPatch) {
        return resultInDefaultTimezone;
      }

      const defaultTimeZoneOffset =
        resultInDefaultTimezone.getTimezoneOffset() * 60000;
      const offset = _currentTimezoneIana
        ? getTimezoneOffset(_currentTimezoneIana, resultInDefaultTimezone)
        : defaultTimeZoneOffset;

      return new (_defaultDate as any)(
        resultInDefaultTimezone.getTime() + (offset + defaultTimeZoneOffset),
      );
    } as any;

    Object.getOwnPropertyNames(_defaultDate).forEach(function (name) {
      if (name === 'length' || name === 'name') return;
      try {
        (Date as any)[name] = (_defaultDate as any)[name];
      } catch (e) {
        console.log(e);
      }
    });

    // we also need to patch toISOString which is used when date is sent to backend
    Date.prototype.toISOString = function () {
      // to send dates with Timezone (2021-01-13T02:04:31+07:00)

      const defaultTimeZoneOffset = this.getTimezoneOffset() * 60000;
      const offset = _currentTimezoneIana
        ? getTimezoneOffset(_currentTimezoneIana, this)
        : defaultTimeZoneOffset;
      const newDate = this.getTime() - (offset + defaultTimeZoneOffset);
      return defaultToISOString(new Date(newDate));
    };

    _isDateMonkeyPatchedAlready = true;
  }
}
